<template>
  <div class="h-100">
    <div class="row m-0 p-0">
      <div :class="isMobile ? 'col-12 text-center' : 'col-auto p-0'">
        <div class="d-inline-block page-title-box-spacing">
          <div class="d-flex align-items-center topbar-right-spacing name-header" :class="isMobile && 'm-0'">
            <div>Գնումների ERP</div>
          </div>
        </div>
      </div>
      <template v-if="isMobile">
        <div class="col-12 text-center p-0">
          <select v-model="activeGroup" @change="setGroup(activeGroup)" class="contract-managment-select">
            <option value="planning">Պլանավորում</option>
            <option value="tenders">Մրցույթ</option>
            <option value="contracts">Պայմանագրեր</option>
            <option value="dashboard">Ամփոփագիր</option>
            <option value="lifecycle">Ցիկլ</option>
          </select>
        </div>
      </template>
      <template v-else>
        <div class="col-auto">
          <div class="d-inline-block">
            <ul class="nav nav-tabs align-items-end suggestions-tab" role="tablist">
              <li class="nav-item">
                <a class="nav-link" :class="activeGroup === 'planning' && 'active'"
                   @click.prevent="setGroup('planning')" href="#">
                  Պլանավորում
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="activeGroup === 'tenders' && 'active'"
                   @click.prevent="setGroup('tenders')" href="#">
                  Մրցույթ
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="activeGroup === 'contracts' && 'active'"
                   @click.prevent="setGroup('contracts')" href="#">
                  Պայմանագրեր
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="activeGroup === 'dashboard' && 'active'"
                   @click.prevent="setGroup('dashboard')" href="#">
                  Ամփոփագիր
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="activeGroup === 'lifecycle' && 'active'"
                   @click.prevent="setGroup('lifecycle')" href="#">
                  Գնումների ընթացք
                </a>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
    <div
      class="tab-content"
      :class="isMobile ? 'suggestions-tab-content-mobile' : 'suggestions-tab-content'"
      id="reportsTabContent"
    >
    <div class="tab-pane fade show active h-100" role="tabpanel">

    <!-- =================== GROUP 1: PLANNING =================== -->
    <template v-if="activeGroup === 'planning'">
      <div class="row m-0 mb-2">
        <div class="col-auto p-0">
          <ul class="nav sub-tabs align-items-end" role="tablist">
            <li class="nav-item">
              <a class="nav-link" :class="activeTab === 'planning' && 'active'"
                 @click.prevent="setTab('planning')" href="#">
                Գնումների պլան
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="activeTab === 'plan-vs-organized' && 'active'"
                 @click.prevent="setTab('plan-vs-organized')" href="#">
                Պլանավորված / Կազմակերպված
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="activeTab === 'unorganized' && 'active'"
                 @click.prevent="setTab('unorganized')" href="#">
                Չկազմակերպված գնումներ
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-body py-3">
          <div class="row align-items-end">
            <div class="col-md-3 col-sm-6 mb-2">
              <label class="filter-label">Գնումների պլան</label>
              <select v-model="filters.procurement_id" class="form-control form-control-sm" @change="loadData">
                <option value="">Բոլորը</option>
                <option v-for="p in procurements" :key="p.id" :value="p.id">{{ p.name }} ({{ p.year }})</option>
              </select>
            </div>
            <div class="col-md-2 col-sm-6 mb-2">
              <label class="filter-label">Գնման ձև</label>
              <select v-model="filters.purchase_type" class="form-control form-control-sm" @change="loadData">
                <option value="">Բոլորը</option>
                <option value="3">Լավագույն առաջարկ</option>
                <option value="2">Բաց աճուրդ</option>
                <option value="1">Փակ գներով</option>
              </select>
            </div>
            <div class="col-md-2 col-sm-6 mb-2">
              <label class="filter-label">Ստորաբաժանում</label>
              <select v-model="filters.classifier" class="form-control form-control-sm" @change="loadData">
                <option value="">Բոլորը</option>
                <option v-for="c in classifiers" :key="c" :value="c">{{ c }}</option>
              </select>
            </div>
            <div class="col-md-2 col-sm-6 mb-2">
              <label class="filter-label">Կարգավիճակ</label>
              <select v-model="filters.status" class="form-control form-control-sm" @change="loadData">
                <option value="">Բոլորը</option>
                <option value="0">Ակտիվ</option>
                <option value="1">Հաստատված</option>
                <option value="2">Խմբագրման մեջ</option>
              </select>
            </div>
            <div class="col-md-3 col-sm-6 mb-2">
              <label class="filter-label">Ժամկետ</label>
              <app-date-range-picker
                  :from="filters.date_from"
                  :to="filters.date_to"
                  @update:from="val => { filters.date_from = val; loadData() }"
                  @update:to="val => { filters.date_to = val; loadData() }">
              </app-date-range-picker>
            </div>
            <div class="col-md-3 col-sm-6 mb-2">
              <label class="filter-label">Որոնում (CPV / անվ.)</label>
              <input v-model="filters.query" type="text" class="form-control form-control-sm"
                     placeholder="ԳՄԱ կամ անվ...." @input="onSearch" />
            </div>
            <div class="col-auto mb-2 ml-auto">
              <button @click="resetFilters" class="btn btn-sm btn-outline-secondary mr-2">
                <i class="mdi mdi-refresh"></i> Մաքրել
              </button>
              <button v-if="false && activeTab === 'planning'" @click="exportExcel" class="btn btn-sm btn-success">
                <i class="mdi mdi-microsoft-excel mr-1"></i> Excel
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body p-0">
          <div class="d-flex align-items-center px-3 pt-3 pb-2">
            <small class="text-muted mr-3">Ընդամենը: <strong>{{ total }}</strong></small>
            <div class="ml-auto">
              <column-selector
                :all-columns="currentAllColumns"
                :visible.sync="currentVisibleColumns"
                :storage-key="columnsStorageKey"
              />
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-hover table-sm report-table mb-0">
              <thead>
                <tr>
                  <th v-for="col in activeColumns" :key="col.key" class="text-nowrap">{{ col.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td :colspan="activeColumns.length" class="text-center py-4">
                    <div class="spinner-border spinner-border-sm text-primary"></div>
                  </td>
                </tr>
                <tr v-else-if="!rows.length">
                  <td :colspan="activeColumns.length" class="text-center py-4 text-muted">Տվյալներ չկան</td>
                </tr>
                <template v-else>
                  <template v-if="activeTab === 'planning'">
                    <tr v-for="row in rows" :key="row.id">
                    <td v-if="isVisible('cpv_code')"><small>{{ row.cpv_code }}</small></td>
                    <td v-if="isVisible('cpv_name')" style="max-width:300px">{{ row.cpv_name }}</td>
                    <td v-if="isVisible('cpv_type')"><small>{{ cpvTypeLabel(row.cpv_type) }}</small></td>
                    <td v-if="isVisible('purchase_type')"><small>{{ row.purchase_type ? purchaseTypeLabel(row.purchase_type) : 'Լավագույն առաջարկ' }}</small></td>
                    <td v-if="isVisible('unit')">{{ row.unit }}</td>
                    <td v-if="isVisible('planned_count')">{{ row.planned_count | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('unit_amount')">{{ row.unit_amount | numeral('0,0') }} դր.</td>
                    <td v-if="isVisible('planned_value')">{{ row.planned_value | numeral('0,0') }} դր.</td>
                    <td v-if="isVisible('organized_total')">{{ (row.organized_itender + row.organized_outside) | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('organized_itender')">{{ row.organized_itender | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('organized_outside')">{{ row.organized_outside | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('remaining')" :class="row.remaining > 0 ? 'text-warning' : 'text-success'">{{ row.remaining | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('execution_pct')">
                      <span class="badge" :class="pctBadge(row.execution_pct)">{{ row.execution_pct }}%</span>
                    </td>
                    <td v-if="isVisible('classifier')"><small>{{ row.classifier || '—' }}</small></td>
                    <td v-if="isVisible('status')">
                      <span class="badge" :class="planStatusBadge(row.status)">{{ planStatusLabel(row.status) }}</span>
                    </td>
                    </tr></template>
                  <template v-if="activeTab === 'plan-vs-organized'">
                    <tr v-for="(row, i) in rows" :key="i">
                    <td v-if="isVisible('cpv_code')"><small>{{ row.cpv_code }}</small></td>
                    <td v-if="isVisible('cpv_name')" style="max-width:280px">{{ row.cpv_name }}</td>
                    <td v-if="isVisible('planned_count')">{{ row.planned_count | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('organized_itender')">{{ row.organized_itender | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('organized_outside')">{{ row.organized_outside | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('remaining')" :class="row.remaining > 0 ? 'text-warning' : 'text-success'">{{ row.remaining | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('planned_value')">{{ row.planned_value | numeral('0,0') }} դր.</td>
                    <td v-if="isVisible('execution_pct')">
                      <span class="badge" :class="pctBadge(row.execution_pct)">{{ row.execution_pct }}%</span>
                    </td>
                    </tr></template>
                  <template v-if="activeTab === 'unorganized'">
                    <tr v-for="row in rows" :key="row.id">
                    <td v-if="isVisible('cpv_code')"><small>{{ row.cpv_code }}</small></td>
                    <td v-if="isVisible('cpv_name')" style="max-width:280px">{{ row.cpv_name }}</td>
                    <td v-if="isVisible('unit')">{{ row.unit }}</td>
                    <td v-if="isVisible('planned_count')">{{ row.planned_count | numeral('0,0.##') }}</td>
                    <td v-if="isVisible('unit_amount')">{{ row.unit_amount | numeral('0,0') }} դր.</td>
                    <td v-if="isVisible('planned_value')" class="font-weight-bold text-danger">{{ row.planned_value | numeral('0,0') }} դր.</td>
                    <td v-if="isVisible('classifier')"><small>{{ row.classifier || '—' }}</small></td>
                    <td v-if="isVisible('date')"><small>{{ row.date | moment('DD.MM.YYYY') }}</small></td>
                    </tr></template>
                </template>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center py-3">
            <nav v-if="totalPages > 1">
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="page <= 1 && 'disabled'">
                  <a class="page-link" href="#" @click.prevent="changePage(page - 1)">&laquo;</a>
                </li>
                <li v-for="p in pagesRange" :key="p" class="page-item" :class="p === page && 'active'">
                  <a class="page-link" href="#" @click.prevent="changePage(p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="page >= totalPages && 'disabled'">
                  <a class="page-link" href="#" @click.prevent="changePage(page + 1)">&raquo;</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </template>

    <!-- =================== GROUP 2: TENDERS =================== -->
    <template v-if="activeGroup === 'tenders'">
      <div class="row m-0 mb-2">
        <div class="col-auto p-0">
          <ul class="nav sub-tabs align-items-end" role="tablist">
            <li class="nav-item">
              <a class="nav-link" :class="activeTenderTab === 'list' && 'active'"
                 @click.prevent="setTenderTab('list')" href="#">
                Մրցույթների ցուցակ
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="activeTenderTab === 'competition' && 'active'"
                 @click.prevent="setTenderTab('competition')" href="#">
                Մրցակցության վերլուծություն
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="activeTenderTab === 'cancelled' && 'active'"
                 @click.prevent="setTenderTab('cancelled')" href="#">
                Չեղարկվածներ
              </a>
            </li>
          </ul>
        </div>
        <div v-if="activeTenderTab !== 'competition'" class="col-auto ml-auto d-flex align-items-center pb-1">
          <input v-model="tenderSearch" type="text" class="form-control form-control-sm"
                 placeholder="Փնտրել..." style="width:200px" @input="onTenderSearch" />
        </div>
      </div>

      <!-- Competition Analysis -->
      <div v-if="activeTenderTab === 'competition'">
        <div v-if="competitionLoading" class="text-center py-5">
          <div class="spinner-border text-primary"></div>
        </div>
        <template v-else>
          <div class="row mb-3">
            <div class="col-md-3 col-sm-6 mb-3">
              <div class="card kpi-card">
                <div class="card-body">
                  <div class="kpi-icon text-primary"><i class="mdi mdi-account-group-outline"></i></div>
                  <div class="kpi-value">{{ competition.avg_participants }}</div>
                  <div class="kpi-label">Միջին մասնակիցների քանակ</div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-6 mb-3">
              <div class="card kpi-card">
                <div class="card-body">
                  <div class="kpi-icon text-warning"><i class="mdi mdi-account-alert-outline"></i></div>
                  <div class="kpi-value">{{ competition.one_participant_count }}</div>
                  <div class="kpi-label">1 մասնակցով մրցույթներ ({{ competition.tender_count }}-ից)</div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header py-2">
              <strong style="font-size:0.85rem;">Մատակարարների ակտիվություն (TOP 15)</strong>
            </div>
            <div class="card-body p-0">
              <div v-if="topSuppliersLoading" class="text-center py-4">
                <div class="spinner-border spinner-border-sm text-primary"></div>
              </div>
              <table v-else-if="topSuppliers.length" class="table table-sm report-table mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Մատակարար</th>
                    <th class="text-right">Մաս.</th>
                    <th class="text-right">🥇</th>
                    <th class="text-right">🥈</th>
                    <th class="text-right">🥉</th>
                    <th class="text-right">Հաղ. %</th>
                    <th class="text-right">Պայ. արժ. (դր.)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in topSuppliers" :key="i">
                    <td>{{ i+1 }}</td>
                    <td>{{ row.name }}</td>
                    <td class="text-right"><span class="badge badge-primary">{{ row.participation }}</span></td>
                    <td class="text-right"><span class="badge badge-success">{{ row.place_1 }}</span></td>
                    <td class="text-right"><span class="badge badge-secondary">{{ row.place_2 }}</span></td>
                    <td class="text-right"><span class="badge badge-secondary">{{ row.place_3 }}</span></td>
                    <td class="text-right"><span class="badge" :class="pctBadge(row.win_pct)">{{ row.win_pct }}%</span></td>
                    <td class="text-right font-weight-bold">{{ row.total_value | numeral('0,0') }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="text-center py-4 text-muted">Տվյալներ չկան</div>
            </div>
          </div>
        </template>
      </div>

      <div v-else class="card">
        <div class="card-body p-0">
          <div class="d-flex align-items-center px-3 pt-3 pb-2">
            <small class="text-muted">Ընդամենը: <strong>{{ activeTenderTab === 'list' ? tenderTotal : cancelledTotal }}</strong></small>
            <div class="ml-auto">
              <column-selector
                :all-columns="currentAllColumns"
                :visible.sync="currentVisibleColumns"
                :storage-key="columnsStorageKey"
              />
            </div>
          </div>

          <!-- Tender List -->
          <div v-if="activeTenderTab === 'list'" class="table-responsive">
            <table class="table table-hover table-sm report-table mb-0">
              <thead>
                <tr>
                  <th v-if="isVisible('name')">Անվանում</th>
                  <th v-if="isVisible('subdivision')">Ստորաբաժանում</th>
                  <th v-if="isVisible('cpv_type')">Գնման ձև</th>
                  <th v-if="isVisible('participants')" class="text-right">Մասնակիցներ</th>
                  <th v-if="isVisible('winner')">Հաղթող</th>
                  <th v-if="isVisible('winner_price')" class="text-right">Հաղթող գին</th>
                  <th v-if="isVisible('status')">Կարգավիճակ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="tenderLoading">
                  <td :colspan="activeColumns.length" class="text-center py-4"><div class="spinner-border spinner-border-sm text-primary"></div></td>
                </tr>
                <tr v-else-if="!tenderRows.length">
                  <td :colspan="activeColumns.length" class="text-center py-4 text-muted">Տվյալներ չկան</td>
                </tr>
                <tr v-for="row in tenderRows" :key="row.id" v-else>
                  <td v-if="isVisible('name')" style="max-width:350px">{{ localizedName(row.name) }}</td>
                  <td v-if="isVisible('subdivision')"><small>{{ row.subdivision || '—' }}</small></td>
                  <td v-if="isVisible('cpv_type')"><small>{{ purchaseTypeLabel(row.purchase_type) }}</small></td>
                  <td v-if="isVisible('participants')" class="text-right">{{ row.participant_count }}</td>
                  <td v-if="isVisible('winner')"><small>{{ localizedName(row.winner_name) }}</small></td>
                  <td v-if="isVisible('winner_price')" class="text-right">{{ row.winner_price ? formatNumeral(row.winner_price, '0,0') + ' դր.' : '—' }}</td>
                  <td v-if="isVisible('status')">
                    <span class="badge" :class="lifecycleBadge(row.lifecycle_status)">{{ lifecycleLabel(row.lifecycle_status) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Cancelled Tenders -->
          <div v-if="activeTenderTab === 'cancelled'" class="table-responsive">
            <table class="table table-hover table-sm report-table mb-0">
              <thead>
                <tr>
                  <th v-if="isVisible('id')">ID</th>
                  <th v-if="isVisible('code')">Ծածկագիր</th>
                  <th v-if="isVisible('name')">Անվանում</th>
                  <th v-if="isVisible('date')">Ժամկետ</th>
                  <th v-if="isVisible('status')">Կարգավիճակ</th>
                  <th v-if="isVisible('cancel_reason')">Չեղարկման պատճառ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="cancelledLoading">
                  <td :colspan="activeColumns.length" class="text-center py-4"><div class="spinner-border spinner-border-sm text-primary"></div></td>
                </tr>
                <tr v-else-if="!cancelledRows.length">
                  <td :colspan="activeColumns.length" class="text-center py-4 text-muted">Տվյալներ չկան</td>
                </tr>
                <tr v-for="row in cancelledRows" :key="row.id" v-else>
                  <td v-if="isVisible('id')"><small>{{ row.id }}</small></td>
                  <td v-if="isVisible('code')"><small>{{ row.code || '—' }}</small></td>
                  <td v-if="isVisible('name')" style="max-width:300px">{{ localizedName(row.name) }}</td>
                  <td v-if="isVisible('date')"><small>{{ row.submission_date | moment('DD.MM.YYYY') }}</small></td>
                  <td v-if="isVisible('status')">
                    <span class="badge" :class="row.is_canceled ? 'badge-danger' : 'badge-warning'">{{ row.status_label }}</span>
                  </td>
                  <td v-if="isVisible('cancel_reason')" style="max-width:250px"><small class="text-muted">{{ cancelReasonLabel(row.cancel_reason) }}</small></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center py-3">
            <nav v-if="activeTenderTab === 'list' && tenderTotalPages > 1">
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="tenderPage <= 1 && 'disabled'">
                  <a class="page-link" href="#" @click.prevent="changeTenderPage(tenderPage - 1)">&laquo;</a>
                </li>
                <li v-for="p in tenderPagesRange" :key="p" class="page-item" :class="p === tenderPage && 'active'">
                  <a class="page-link" href="#" @click.prevent="changeTenderPage(p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="tenderPage >= tenderTotalPages && 'disabled'">
                  <a class="page-link" href="#" @click.prevent="changeTenderPage(tenderPage + 1)">&raquo;</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </template>

    <!-- =================== GROUP 3: CONTRACTS =================== -->
    <template v-if="activeGroup === 'contracts'">
      <div class="row m-0 mb-2">
        <div class="col-auto p-0">
          <ul class="nav sub-tabs align-items-end" role="tablist">
            <li class="nav-item">
              <a class="nav-link" :class="activeContractTab === 'list' && 'active'"
                 @click.prevent="setContractTab('list')" href="#">
                Ռեեստր
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="activeContractTab === 'execution' && 'active'"
                 @click.prevent="setContractTab('execution')" href="#">
                Կատարում
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="activeContractTab === 'overdue' && 'active'"
                 @click.prevent="setContractTab('overdue')" href="#">
                Ժամկետանց
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="activeContractTab === 'savings' && 'active'"
                 @click.prevent="setContractTab('savings')" href="#">
                Խնայողություն
              </a>
            </li>
          </ul>
        </div>
        <div v-if="activeContractTab === 'list'" class="col-auto ml-auto d-flex align-items-center pb-1">
          <input v-model="contractSearch" type="text" class="form-control form-control-sm"
                 placeholder="Փնտրել..." style="width:200px" @input="onContractSearch" />
        </div>
      </div>

      <!-- Execution KPIs -->
      <div v-if="activeContractTab === 'execution'">
        <div v-if="executionLoading" class="text-center py-5">
          <div class="spinner-border text-primary"></div>
        </div>
        <template v-else>
          <div class="card">
            <div class="card-body p-0">
              <div class="d-flex align-items-center px-3 pt-3 pb-2">
                <div class="ml-auto">
                  <column-selector
                    :all-columns="currentAllColumns"
                    :visible.sync="currentVisibleColumns"
                    :storage-key="columnsStorageKey"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover table-sm report-table mb-0">
                  <thead>
                    <tr>
                      <th v-if="isVisible('status')">Կարգավիճակ</th>
                      <th v-if="isVisible('code')">Ծածկ. №</th>
                      <th v-if="isVisible('name')">Անվանում</th>
                      <th v-if="isVisible('provider')">Մատակարար</th>
                      <th v-if="isVisible('planned')" class="text-right">Պլանավ.</th>
                      <th v-if="isVisible('supplied')" class="text-right">Մատակարարված</th>
                      <th v-if="isVisible('remaining')" class="text-right">Մնացորդ</th>
                      <th v-if="isVisible('exec_pct')" class="text-right">Կատ. %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!executionRows.length">
                      <td colspan="8" class="text-center py-4 text-muted">Տvyalner chkan</td>
                    </tr>
                    <tr v-for="row in executionRows" :key="row.id" v-else>
                      <td v-if="isVisible('status')">
                        <span v-if="row.status === 'completed'">🔵 Ավարտված</span>
                        <span v-else-if="row.status === 'overdue'">🔴 Ժամկետանց</span>
                        <span v-else-if="row.status === 'partial'">🟠 Մասնակի կատարված</span>
                        <span v-else>🟢 Կատարվում է</span>
                      </td>
                      <td v-if="isVisible('code')"><small>{{ row.code || '—' }}</small></td>
                      <td v-if="isVisible('name')" style="max-width:280px">{{ localizedName(row.name) }}</td>
                      <td v-if="isVisible('provider')" style="max-width:200px"><small>{{ row.provider_name }}</small></td>
                      <td v-if="isVisible('planned')" class="text-right">{{ row.planned_value | numeral('0,0') }} դր.</td>
                      <td v-if="isVisible('supplied')" class="text-right">{{ row.supplied_value | numeral('0,0') }} դր.</td>
                      <td v-if="isVisible('remaining')" class="text-right" :class="row.remaining_value > 0 ? 'text-warning' : 'text-success'">{{ row.remaining_value | numeral('0,0') }} դր.</td>
                      <td v-if="isVisible('exec_pct')" class="text-right">
                        <span class="badge" :class="pctBadge(row.execution_pct)">{{ row.execution_pct }}%</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-center py-3">
                <nav v-if="executionTotalPages > 1">
                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" :class="executionPage <= 1 && 'disabled'">
                      <a class="page-link" href="#" @click.prevent="changeExecutionPage(executionPage - 1)">&laquo;</a>
                    </li>
                    <li v-for="p in executionPagesRange" :key="p" class="page-item" :class="p === executionPage && 'active'">
                      <a class="page-link" href="#" @click.prevent="changeExecutionPage(p)">{{ p }}</a>
                    </li>
                    <li class="page-item" :class="executionPage >= executionTotalPages && 'disabled'">
                      <a class="page-link" href="#" @click.prevent="changeExecutionPage(executionPage + 1)">&raquo;</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- Overdue Contracts -->
      <div v-else-if="activeContractTab === 'overdue'" class="card">
        <div class="card-body p-0">
          <div class="d-flex align-items-center px-3 pt-3 pb-2">
            <small class="text-muted">Ընդամենը: <strong>{{ overdueRows.length }}</strong></small>
            <div class="ml-auto">
              <column-selector
                :all-columns="currentAllColumns"
                :visible.sync="currentVisibleColumns"
                :storage-key="columnsStorageKey"
              />
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-hover table-sm report-table mb-0">
              <thead>
                <tr>
                  <th v-if="isVisible('code')">Ծածկ. №</th>
                  <th v-if="isVisible('name')">Անվանում</th>
                  <th v-if="isVisible('provider')">Մատակարար</th>
                  <th v-if="isVisible('delivery_date')">Մատակ. ժամկետ</th>
                  <th v-if="isVisible('ordered')" class="text-right">Պատվ.</th>
                  <th v-if="isVisible('supplied')" class="text-right">Մատակ.</th>
                  <th v-if="isVisible('overdue_value')" class="text-right">Ժամկ. գումար</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="overdueLoading">
                  <td :colspan="activeColumns.length" class="text-center py-4"><div class="spinner-border spinner-border-sm text-primary"></div></td>
                </tr>
                <tr v-else-if="!overdueRows.length">
                  <td :colspan="activeColumns.length" class="text-center py-4 text-muted">Տվյալներ չկան</td>
                </tr>
                <tr v-for="row in overdueRows" :key="row.id" v-else>
                  <td v-if="isVisible('code')"><small>{{ row.code || '—' }}</small></td>
                  <td v-if="isVisible('name')" style="max-width:280px">{{ localizedName(row.name) }}</td>
                  <td v-if="isVisible('provider')" style="max-width:200px">
                    <small>{{ localizedName(row.provider_name) }}</small>
                    <br v-if="row.provider_company_type"><small v-if="row.provider_company_type" class="text-muted">{{ row.provider_company_type }}</small>
                  </td>
                  <td v-if="isVisible('delivery_date')"><small class="text-danger">{{ row.delivery_date | moment('DD.MM.YYYY') }}</small></td>
                  <td v-if="isVisible('ordered')" class="text-right">{{ row.ordered_qty | numeral('0,0.##') }}</td>
                  <td v-if="isVisible('supplied')" class="text-right">{{ row.supplied_qty | numeral('0,0.##') }}</td>
                  <td v-if="isVisible('overdue_value')" class="text-right font-weight-bold text-danger">{{ row.overdue_value | numeral('0,0') }} դր.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else class="card">
        <div class="card-body p-0">
          <div class="d-flex align-items-center px-3 pt-3 pb-2">
            <small class="text-muted">Ընդամենը: <strong>{{ activeContractTab === 'list' ? contractTotal : savingsTotal }}</strong></small>
            <div class="ml-auto">
              <column-selector
                :all-columns="currentAllColumns"
                :visible.sync="currentVisibleColumns"
                :storage-key="columnsStorageKey"
              />
            </div>
          </div>

          <!-- Contract List -->
          <div v-if="activeContractTab === 'list'" class="table-responsive">
            <table class="table table-hover table-sm report-table mb-0">
              <thead>
                <tr>
                  <th v-if="isVisible('code')" style="white-space:nowrap">Ծածկ. №</th>
                  <th v-if="isVisible('name')">Անվանում</th>
                  <th v-if="isVisible('provider')">Մատակարար</th>
                  <th v-if="isVisible('price')" style="white-space:nowrap">Գումար</th>
                  <th v-if="isVisible('start')" style="white-space:nowrap">Սկիզբ</th>
                  <th v-if="isVisible('end')" style="white-space:nowrap">Ավարտ</th>
                  <th v-if="isVisible('status')">Կարգավիճակ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="contractLoading">
                  <td :colspan="activeColumns.length" class="text-center py-4"><div class="spinner-border spinner-border-sm text-primary"></div></td>
                </tr>
                <tr v-else-if="!contractRows.length">
                  <td :colspan="activeColumns.length" class="text-center py-4 text-muted">Տվյալներ չկան</td>
                </tr>
                <tr v-for="row in contractRows" :key="row.id" v-else>
                  <td v-if="isVisible('code')" style="white-space:nowrap">{{ row.code || '—' }}</td>
                  <td v-if="isVisible('name')" style="max-width:300px">{{ localizedName(row.name) }}</td>
                  <td v-if="isVisible('provider')" style="max-width:200px">{{ localizedName(row.provider_name) }}<span v-if="row.provider_company_type" class="text-muted text-sm"> · {{ row.provider_company_type }}</span></td>
                  <td v-if="isVisible('price')" style="white-space:nowrap">{{ row.price | numeral('0,0') }} դր.</td>
                  <td v-if="isVisible('start')" style="white-space:nowrap">{{ formatDate(row.sign_date) }}</td>
                  <td v-if="isVisible('end')" style="white-space:nowrap">{{ formatDate(row.end_date) }}</td>
                  <td v-if="isVisible('status')">
                    <span class="badge" :class="row.is_sign ? 'badge-success' : 'badge-secondary'">
                      {{ row.is_sign ? 'Ստորագրված' : 'Սպասվող' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center py-3">
              <nav v-if="contractTotalPages > 1">
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="contractPage <= 1 && 'disabled'">
                    <a class="page-link" href="#" @click.prevent="changeContractPage(contractPage - 1)">&laquo;</a>
                  </li>
                  <li v-for="p in contractPagesRange" :key="p" class="page-item" :class="p === contractPage && 'active'">
                    <a class="page-link" href="#" @click.prevent="changeContractPage(p)">{{ p }}</a>
                  </li>
                  <li class="page-item" :class="contractPage >= contractTotalPages && 'disabled'">
                    <a class="page-link" href="#" @click.prevent="changeContractPage(contractPage + 1)">&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <!-- Savings Report -->
          <div v-if="activeContractTab === 'savings'">
            <!-- Filters -->
            <div class="px-3 pt-3 pb-2 border-bottom">
              <div class="row align-items-end">
                <div class="col-md-1 col-sm-6 mb-2">
                  <label class="filter-label">Տարի</label>
                  <select v-model="savingsFilters.year" class="form-control form-control-sm" @change="onSavingsFilter">
                    <option value="">Բոլորը</option>
                    <option v-for="y in savingsYears" :key="y" :value="y">{{ y }}</option>
                  </select>
                </div>
                <div class="col-md-3 col-sm-6 mb-2">
                  <label class="filter-label">Ժամկետ</label>
                  <app-date-range-picker
                    :from="savingsFilters.date_from"
                    :to="savingsFilters.date_to"
                    @update:from="val => { savingsFilters.date_from = val; onSavingsFilter() }"
                    @update:to="val => { savingsFilters.date_to = val; onSavingsFilter() }">
                  </app-date-range-picker>
                </div>
                <div class="col-md-2 col-sm-6 mb-2">
                  <label class="filter-label">Ստորաբաժանում</label>
                  <select v-model="savingsFilters.subdivision" class="form-control form-control-sm" @change="onSavingsFilter">
                    <option value="">Բոլորը</option>
                    <option v-for="s in savingsSubdivisions" :key="s" :value="s">{{ s }}</option>
                  </select>
                </div>
                <div class="col-md-3 col-sm-6 mb-2">
                  <label class="filter-label">Մատակարար</label>
                  <input v-model="savingsFilters.supplier" type="text" class="form-control form-control-sm" style="height:calc(1.5em + 0.5rem + 2px); margin:0;" placeholder="Փնտրել..." @input="onSavingsFilterDebounce" />
                </div>
                <div class="col-md-2 col-sm-6 mb-2">
                  <label class="filter-label">Գնման ձև</label>
                  <select v-model="savingsFilters.procurement_type" class="form-control form-control-sm" @change="onSavingsFilter">
                    <option value="">Բոլորը</option>
                    <option value="3">Լավագույն առաջարկ</option>
                    <option value="2">Բաց աճուրդ</option>
                    <option value="1">Փակ գներով</option>
                  </select>
                </div>
                <div class="col-auto mb-2 ml-auto d-flex align-items-end">
                  <button @click="exportSavingsExcel" class="btn btn-sm btn-outline-success">
                    <i class="mdi mdi-file-excel"></i> Excel
                  </button>
                </div>
              </div>
            </div>
            <div v-if="savingsLoading" class="text-center py-5"><div class="spinner-border text-primary"></div></div>
            <div v-else>
              <div class="table-responsive">
                <table class="table table-hover table-sm report-table mb-0">
                  <thead>
                    <tr>
                      <th v-if="isVisible('code')" style="white-space:nowrap">Պայմ. №</th>
                      <th v-if="isVisible('organize_name')">Մրցույթ</th>
                      <th v-if="isVisible('provider_name')">Մատակարար</th>
                      <th v-if="isVisible('subdivision')">Ստորաբ.</th>
                      <th v-if="isVisible('planned_value')" class="text-right">Պլան. արժ.</th>
                      <th v-if="isVisible('contract_price')" class="text-right">Պայմ. արժ.</th>
                      <th v-if="isVisible('savings')" class="text-right">Խնայողություն</th>
                      <th v-if="isVisible('savings_pct')" class="text-right">Խնայ. %</th>
                      <th v-if="isVisible('sign_date')" class="text-center">Ստ. ամս.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!savingsData.length">
                      <td colspan="9" class="text-center py-4 text-muted">Տվյալներ չկան</td>
                    </tr>
                    <tr v-for="(row, i) in savingsData" :key="row.id || i" v-else>
                      <td v-if="isVisible('code')" style="white-space:nowrap"><small>{{ row.code }}</small></td>
                      <td v-if="isVisible('organize_name')" style="max-width:280px"><small>{{ row.organize_name }}</small></td>
                      <td v-if="isVisible('provider_name')" style="max-width:200px"><small>{{ row.provider_name }}</small></td>
                      <td v-if="isVisible('subdivision')"><small>{{ row.subdivision }}</small></td>
                      <td v-if="isVisible('planned_value')" class="text-right">{{ row.planned_value | numeral('0,0') }} դր.</td>
                      <td v-if="isVisible('contract_price')" class="text-right">{{ row.contract_price | numeral('0,0') }} դր.</td>
                      <td v-if="isVisible('savings')" class="text-right font-weight-bold" :class="row.savings > 0 ? 'text-success' : 'text-muted'">{{ row.savings | numeral('0,0') }} դր.</td>
                      <td v-if="isVisible('savings_pct')" class="text-right"><span class="badge" :class="pctBadge(row.savings_pct)">{{ row.savings_pct }}%</span></td>
                      <td v-if="isVisible('sign_date')" class="text-center">{{ formatDate(row.sign_date) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-center py-3">
                <nav v-if="savingsTotalPages > 1">
                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" :class="savingsPage <= 1 && 'disabled'">
                      <a class="page-link" href="#" @click.prevent="changeSavingsPage(savingsPage - 1)">&laquo;</a>
                    </li>
                    <li v-for="p in savingsPagesRange" :key="p" class="page-item" :class="p === savingsPage && 'active'">
                      <a class="page-link" href="#" @click.prevent="changeSavingsPage(p)">{{ p }}</a>
                    </li>
                    <li class="page-item" :class="savingsPage >= savingsTotalPages && 'disabled'">
                      <a class="page-link" href="#" @click.prevent="changeSavingsPage(savingsPage + 1)">&raquo;</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- =================== GROUP 4: DASHBOARD =================== -->
    <div v-if="activeGroup === 'dashboard'">
      <div v-if="dashLoading" class="text-center py-5">
        <div class="spinner-border text-primary"></div>
      </div>
      <template v-else>
        <!-- 6 KPI Cards -->
        <div class="row mb-3">
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="card kpi-card">
              <div class="card-body">
                <div class="kpi-icon text-primary"><i class="mdi mdi-currency-usd"></i></div>
                <div class="kpi-value">{{ dash.planned_value | numeral('0,0') }} <small>դր.</small></div>
                <div class="kpi-label">Պլանավորված արժեք</div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="card kpi-card">
              <div class="card-body">
                <div class="kpi-icon text-info"><i class="mdi mdi-gavel"></i></div>
                <div class="kpi-value">{{ dash.organized_count }}</div>
                <div class="kpi-label">Կազմակերպված մրցույթներ</div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="card kpi-card">
              <div class="card-body">
                <div class="kpi-icon text-success"><i class="mdi mdi-file-check-outline"></i></div>
                <div class="kpi-value">{{ dash.contract_count }}</div>
                <div class="kpi-label">Կնքված պայմանագրեր</div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="card kpi-card">
              <div class="card-body">
                <div class="kpi-icon text-success"><i class="mdi mdi-trending-down"></i></div>
                <div class="kpi-value text-success">{{ dash.savings | numeral('0,0') }} <small>դր.</small></div>
                <div class="kpi-label">Ընդհանուր խնայողություն &mdash; {{ dash.savings_pct }}%</div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="card kpi-card">
              <div class="card-body">
                <div class="kpi-icon text-primary"><i class="mdi mdi-truck-outline"></i></div>
                <div class="kpi-value">{{ dash.execution_pct }}%</div>
                <div class="kpi-label">Կատարման տոկոս <small class="text-muted d-block">(պայմանագրերի կատարման ընդհանուր տոկոս)</small></div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="card kpi-card" :class="dash.overdue_count > 0 ? 'border-danger' : ''">
              <div class="card-body">
                <div class="kpi-icon text-danger"><i class="mdi mdi-clock-alert-outline"></i></div>
                <div class="kpi-value" :class="dash.overdue_count > 0 ? 'text-danger' : ''">{{ dash.overdue_count }}</div>
                <div class="kpi-label">Ժամկետանց պայմանագրեր</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Monthly activity chart -->
        <div class="card mb-3">
          <div class="card-header py-2">
            <strong style="font-size:0.85rem;">Ամսական ակտիվություն (12 ամիս)</strong>
          </div>
          <div class="card-body">
            <dashboard-monthly-chart v-if="dash.monthly && dash.monthly.length" :monthly="dash.monthly"></dashboard-monthly-chart>
            <div v-else class="text-center py-4 text-muted">Տվյալներ չկան</div>
          </div>
        </div>

        <!-- Top goods / top suppliers -->
        <div class="row mb-3">
          <div class="col-md-6 mb-3">
            <div class="card h-100">
              <div class="card-header py-2">
                <strong style="font-size:0.85rem;">Ամենաշատ գնվող ապրանքներ (Top 10)</strong>
              </div>
              <div class="card-body p-0">
                <div v-if="topGoodsLoading" class="text-center py-4">
                  <div class="spinner-border spinner-border-sm text-primary"></div>
                </div>
                <table v-else-if="topGoods.length" class="table table-sm report-table mb-0">
                  <thead>
                    <tr>
                      <th>ԳՄԱ կոդ</th>
                      <th>Անվանում</th>
                      <th class="text-right">Քանակ</th>
                      <th class="text-right">Արժեք (դր.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in topGoods" :key="row.code">
                      <td>{{ row.code }}</td>
                      <td>{{ localizedName(row.name) }}</td>
                      <td class="text-right">{{ row.total_qty }}</td>
                      <td class="text-right font-weight-bold">{{ row.total_value | numeral('0,0') }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="text-center py-4 text-muted">Տվյալներ չկան</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="card h-100">
              <div class="card-header py-2">
                <strong style="font-size:0.85rem;">Ամենաակտիվ ստորաբաժանումներ</strong>
              </div>
              <div class="card-body p-0">
                <div v-if="departmentsLoading" class="text-center py-4">
                  <div class="spinner-border spinner-border-sm text-primary"></div>
                </div>
                <table v-else-if="departments.length" class="table table-sm report-table mb-0">
                  <thead>
                    <tr>
                      <th>Ստորաբաժանում</th>
                      <th class="text-right">Մրցույթ</th>
                      <th class="text-right">Պայմանագիր</th>
                      <th class="text-right">Գումար (դր.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in departments" :key="row.classifier">
                      <td>{{ row.classifier }}</td>
                      <td class="text-right">{{ row.tender_count }}</td>
                      <td class="text-right">{{ row.contract_count }}</td>
                      <td class="text-right font-weight-bold">{{ row.value | numeral('0,0') }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="text-center py-4 text-muted">Տվյալներ չկան</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Top suppliers (full width) -->
        <div class="row mb-3">
          <div class="col-12 mb-3">
            <div class="card">
              <div class="card-header py-2">
                <strong style="font-size:0.85rem;">Ամենաակտիվ մատակարարներ (TOP 15)</strong>
              </div>
              <div class="card-body p-0">
                <div v-if="topSuppliersLoading" class="text-center py-4">
                  <div class="spinner-border spinner-border-sm text-primary"></div>
                </div>
                <table v-else-if="topSuppliers.length" class="table table-sm report-table mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Մատակարար</th>
                      <th class="text-right">Մաս.</th>
                      <th class="text-right">🥇</th>
                      <th class="text-right">🥈</th>
                      <th class="text-right">🥉</th>
                      <th class="text-right">Հաղ. %</th>
                      <th class="text-right">Պայ. արժ. (դր.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in topSuppliers" :key="i">
                      <td>{{ i+1 }}</td>
                      <td>{{ row.name }}</td>
                      <td class="text-right"><span class="badge badge-primary">{{ row.participation }}</span></td>
                      <td class="text-right"><span class="badge badge-success">{{ row.place_1 }}</span></td>
                      <td class="text-right"><span class="badge badge-secondary">{{ row.place_2 }}</span></td>
                      <td class="text-right"><span class="badge badge-secondary">{{ row.place_3 }}</span></td>
                      <td class="text-right"><span class="badge" :class="pctBadge(row.win_pct)">{{ row.win_pct }}%</span></td>
                      <td class="text-right font-weight-bold">{{ row.total_value | numeral('0,0') }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="text-center py-4 text-muted">Տվյալներ չկան</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Upcoming actions / quick stats -->
        <div class="row mb-3">
          <div class="col-md-7 mb-3">
            <div class="card h-100">
              <div class="card-header py-2">
                <strong style="font-size:0.85rem;">Առաջիկա 7 օր</strong>
              </div>
              <div class="card-body p-0">
                <div v-if="upcomingLoading" class="text-center py-4">
                  <div class="spinner-border spinner-border-sm text-primary"></div>
                </div>
                <ul v-else-if="upcoming.length" class="list-group list-group-flush">
                  <li v-for="(ev, i) in upcoming" :key="i" class="list-group-item d-flex align-items-center py-2" style="font-size:0.85rem;">
                    <span class="mr-2">{{ upcomingIcon(ev.color) }}</span>
                    <span class="flex-grow-1">{{ ev.text }}</span>
                    <small v-if="ev.date" class="text-muted ml-2">{{ formatDate(ev.date) }}</small>
                  </li>
                </ul>
                <div v-else class="text-center py-4 text-muted">Առաջիկա 7 օրում գործողություններ չկան</div>
              </div>
            </div>
          </div>
          <div class="col-md-5 mb-3">
            <div class="card h-100">
              <div class="card-header py-2">
                <strong style="font-size:0.85rem;">Արագ վիճակագրություն</strong>
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span>Պլանավորված գնումներ</span>
                  <strong>{{ dash.quick_stats && dash.quick_stats.planned }}</strong>
                </div>
                <div class="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span>Կազմակերպված</span>
                  <strong>{{ dash.quick_stats && dash.quick_stats.organized }}</strong>
                </div>
                <div class="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span>Պայմանագիր</span>
                  <strong>{{ dash.quick_stats && dash.quick_stats.contracted }}</strong>
                </div>
                <div class="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span>Ավարտված</span>
                  <strong class="text-success">{{ dash.quick_stats && dash.quick_stats.completed }}</strong>
                </div>
                <div class="d-flex justify-content-between align-items-center py-2">
                  <span>Ընթացքի մեջ</span>
                  <strong class="text-primary">{{ dash.quick_stats && dash.quick_stats.in_progress }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Recent contracts -->
        <div class="row mb-3">
          <div class="col-12 mb-3">
            <div class="card">
              <div class="card-header py-2">
                <strong style="font-size:0.85rem;">Վերջին 10 պայմանագրերը</strong>
              </div>
              <div class="card-body p-0">
                <div v-if="recentContractsLoading" class="text-center py-4">
                  <div class="spinner-border spinner-border-sm text-primary"></div>
                </div>
                <table v-else-if="recentContracts.length" class="table table-sm report-table mb-0">
                  <thead>
                    <tr>
                      <th>Ամսաթիվ</th>
                      <th>Պայմանագիր</th>
                      <th>Մատակարար</th>
                      <th class="text-right">Գումար (դր.)</th>
                      <th>Կարգավիճակ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in recentContracts" :key="row.id">
                      <td>{{ formatDate(row.sign_date) }}</td>
                      <td style="max-width:280px">{{ localizedName(row.name) }}<br><small class="text-muted">{{ row.code }}</small></td>
                      <td>{{ localizedName(row.provider_name) }}</td>
                      <td class="text-right font-weight-bold">{{ row.price | numeral('0,0') }}</td>
                      <td>{{ recentContractStatusLabel(row.status) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="text-center py-4 text-muted">Տվյալներ չկան</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>


    <!-- =================== GROUP 5: LIFECYCLE (UNIVERSAL REPORT) =================== -->
    <template v-if="activeGroup === 'lifecycle'">
      <div class="card mb-3">
        <div class="card-body py-3">
          <div class="row align-items-end">
            <div class="col-md-3 col-sm-6 mb-2">
              <label class="filter-label">Գնումների պլան</label>
              <select v-model="lifecycleFilters.procurement_id" class="form-control form-control-sm" @change="loadLifecycle(1)">
                <option value="">Բոլորը</option>
                <option v-for="p in procurements" :key="p.id" :value="p.id">{{ p.name }} ({{ p.year }})</option>
              </select>
            </div>
            <div class="col-md-3 col-sm-6 mb-2">
              <label class="filter-label">Ժամանակահատված</label>
              <app-date-range-picker
                  :from="lifecycleFilters.date_from"
                  :to="lifecycleFilters.date_to"
                  @update:from="val => { lifecycleFilters.date_from = val; loadLifecycle(1) }"
                  @update:to="val => { lifecycleFilters.date_to = val; loadLifecycle(1) }">
              </app-date-range-picker>
            </div>
            <div class="col-md-2 col-sm-6 mb-2">
              <label class="filter-label">Ստորաբաժանում</label>
              <select v-model="lifecycleFilters.classifier" class="form-control form-control-sm" @change="loadLifecycle(1)">
                <option value="">Բոլորը</option>
                <option v-for="c in classifiers" :key="c" :value="c">{{ c }}</option>
              </select>
            </div>
            <div class="col-md-2 col-sm-6 mb-2">
              <label class="filter-label">Մատակարար</label>
              <select v-model="lifecycleFilters.winner_user_id" class="form-control form-control-sm" @change="loadLifecycle(1)">
                <option value="">Բոլորը</option>
                <option v-for="s in lifecycleSuppliers" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select>
            </div>
            <div class="col-md-2 col-sm-6 mb-2">
              <label class="filter-label">Գնման ձև</label>
              <select v-model="lifecycleFilters.cpv_type" class="form-control form-control-sm" @change="loadLifecycle(1)">
                <option value="">Բոլորը</option>
                <option value="3">Լավագույն առաջարկ</option>
                <option value="2">Բաց աճուրդ</option>
                <option value="1">Փակ գներով</option>
              </select>
            </div>
          </div>
          <div class="row align-items-end">
            <div class="col-md-2 col-sm-6 mb-2">
              <label class="filter-label">Կարգավիճակ</label>
              <select v-model="lifecycleFilters.status" class="form-control form-control-sm" @change="loadLifecycle(1)">
                <option value="">Բոլորը</option>
                <option value="planned">Պլանավորում</option>
                <option value="organizing">Կազմակերպվում է</option>
                <option value="contract">Պայմանագիր</option>
                <option value="completed">Ավարտված</option>
                <option value="cancelled">Չեղարկված</option>
              </select>
            </div>
            <div class="col-md-3 col-sm-6 mb-2">
              <label class="filter-label">Որոնում (CPV / անվ.)</label>
              <input v-model="lifecycleFilters.query" type="text" class="form-control form-control-sm m-0"
                     placeholder="ԳՄԱ կամ անվ...." @input="onLifecycleSearch" />
            </div>
            <div class="col-auto mb-2 ml-auto">
              <button @click="resetLifecycleFilters" class="btn btn-sm btn-outline-secondary mr-2">
                <i class="mdi mdi-refresh"></i> Մաքրել
              </button>
              <button @click="exportLifecycleExcel" class="btn btn-sm btn-success">
                <i class="mdi mdi-microsoft-excel mr-1"></i> Excel-ով արտահանել
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body p-0">
          <div class="d-flex align-items-center px-3 pt-3 pb-2">
            <small class="text-muted">Ընդամենը: <strong>{{ lifecycleTotal }}</strong></small>
            <div class="ml-auto">
              <column-selector
                :all-columns="currentAllColumns"
                :visible.sync="currentVisibleColumns"
                :storage-key="columnsStorageKey"
              />
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-hover table-sm report-table mb-0">
              <thead>
                <tr>
                  <th v-if="isVisible('cpv')">ԳՄԱ</th>
                  <th v-if="isVisible('subdivision')">Ստորաբ.</th>
                  <th v-if="isVisible('planned')" class="text-right">Պլան. քանակ/արժեք</th>
                  <th v-if="isVisible('tender')">Մրցույթ</th>
                  <th v-if="isVisible('winner')">Հաղթող</th>
                  <th v-if="isVisible('contract')">Պայմանագիր</th>
                  <th v-if="isVisible('supply')" class="text-right">Մատակարարում</th>
                  <th v-if="isVisible('remaining')" class="text-right">Մնացորդ</th>
                  <th v-if="isVisible('status')">Կարգավիճակ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="lifecycleLoading">
                  <td :colspan="activeColumns.length" class="text-center py-4"><div class="spinner-border spinner-border-sm text-primary"></div></td>
                </tr>
                <tr v-else-if="!lifecycleRows.length">
                  <td :colspan="activeColumns.length" class="text-center py-4 text-muted">Տվյալներ չկան</td>
                </tr>
                <tr v-for="row in lifecycleRows" :key="row.plan_detail_id" v-else>
                  <td v-if="isVisible('cpv')" style="max-width:260px">
                    <small class="text-muted">{{ row.cpv_code }}</small><br>
                    {{ row.cpv_name }}
                  </td>
                  <td v-if="isVisible('subdivision')"><small>{{ row.subdivision }}</small></td>
                  <td v-if="isVisible('planned')" class="text-right">
                    {{ row.planned_count | numeral('0,0.##') }} {{ row.unit }}<br>
                    <small class="text-muted">{{ row.planned_value | numeral('0,0') }} դր.</small>
                  </td>
                  <td v-if="isVisible('tender')" style="max-width:200px">
                    <small>{{ row.tender_code }}</small><br>
                    <small class="text-muted">{{ row.tender_name }}</small>
                  </td>
                  <td v-if="isVisible('winner')" style="max-width:180px">
                    <span v-if="row.winner_company_type" class="text-muted"><small>{{ row.winner_company_type }}</small> </span>{{ row.winner_name }}<br>
                    <small v-if="row.winner_price" class="text-muted">{{ row.winner_price | numeral('0,0') }} դր.</small>
                  </td>
                  <td v-if="isVisible('contract')">
                    <small>{{ row.contract_code }}</small><br>
                    <small v-if="row.contract_price" class="text-muted">{{ row.contract_price | numeral('0,0') }} դր.</small>
                  </td>
                  <td v-if="isVisible('supply')" class="text-right">
                    {{ row.supplied_qty | numeral('0,0.##') }} / {{ row.ordered_qty | numeral('0,0.##') }}<br>
                    <small v-if="row.delivery_date" class="text-muted">{{ row.delivery_date | moment('DD.MM.YYYY') }}</small>
                  </td>
                  <td v-if="isVisible('remaining')" class="text-right" :class="(row.planned_count - row.supplied_qty) > 0 ? 'text-warning' : 'text-success'">
                    {{ (row.planned_count - row.supplied_qty) | numeral('0,0.##') }} {{ row.unit }}
                  </td>
                  <td v-if="isVisible('status')">
                    <span class="badge" :class="lifecycleStatusBadge(row.lifecycle_status)">
                      {{ lifecycleStatusLabel(row.lifecycle_status) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center py-3">
            <nav v-if="lifecycleTotalPages > 1">
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" :class="lifecyclePage <= 1 && 'disabled'">
                  <a class="page-link" href="#" @click.prevent="changeLifecyclePage(lifecyclePage - 1)">&laquo;</a>
                </li>
                <li v-for="p in lifecyclePagesRange" :key="p" class="page-item" :class="p === lifecyclePage && 'active'">
                  <a class="page-link" href="#" @click.prevent="changeLifecyclePage(p)">{{ p }}</a>
                </li>
                <li class="page-item" :class="lifecyclePage >= lifecycleTotalPages && 'disabled'">
                  <a class="page-link" href="#" @click.prevent="changeLifecyclePage(lifecyclePage + 1)">&raquo;</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </template>
    </div>
    </div>
  </div>
</template>

<script>
import ColumnSelector from '../../../state/reports/partials/ColumnSelector'

import AppDateRangePicker from '../../../../components/helpers/AppDateRangePicker'
import DashboardMonthlyChart from './partials/DashboardMonthlyChart'
import isMobile from '@/mixins/isMobileView'

const PLANNING_ENDPOINTS = {
  'planning': 'reports/planning',
  'plan-vs-organized': 'reports/plan-vs-organized',
  'unorganized': 'reports/unorganized',
}

const COLUMN_STORAGE_KEYS = {
  planning: 'org_report_planning_cols_v3',
  'plan-vs-organized': 'org_report_pvs_cols',
  unorganized: 'org_report_unorg_cols_v2',
  lifecycle: 'org_report_lifecycle_cols',
  tenders_list: 'org_report_tenders_list_cols',
  tenders_cancelled: 'org_report_tenders_cancelled_cols',
  contracts_execution: 'org_report_contracts_execution_cols',
  contracts_overdue: 'org_report_contracts_overdue_cols',
  contracts_list: 'org_report_contracts_list_cols',
  contracts_savings: 'org_report_contracts_savings_cols',
}

const ALL_COLUMNS = {
  planning: [
    { key: 'cpv_code', label: 'ԳՄԱ կոդ' },
    { key: 'cpv_name', label: 'Անվանում' },
    { key: 'cpv_type', label: 'Գնման տեսակ' },
    { key: 'purchase_type', label: 'Գնման ձև' },
    { key: 'unit', label: 'Չ/մ' },
    { key: 'planned_count', label: 'Պլան. քանակ' },
    { key: 'unit_amount', label: 'Միավ. գին' },
    { key: 'planned_value', label: 'Պլան. արժեք' },
    { key: 'organized_total', label: 'Կազմակերպված' },
    { key: 'organized_itender', label: 'iTender կազմ.' },
    { key: 'organized_outside', label: 'Արտ. կազմ.' },
    { key: 'remaining', label: 'Մնացորդ' },
    { key: 'execution_pct', label: 'Կատ. %' },
    { key: 'classifier', label: 'Ստորաբ.' },
    { key: 'status', label: 'Կարգավիճակ' },
  ],
  'plan-vs-organized': [
    { key: 'cpv_code', label: 'ԳՄԱ կոդ' },
    { key: 'cpv_name', label: 'Անվանում' },
    { key: 'planned_count', label: 'Պլան. քանակ' },
    { key: 'organized_itender', label: 'iTender կազմ.' },
    { key: 'organized_outside', label: 'Համակարգից դուրս' },
    { key: 'remaining', label: 'Մնացորդ' },
    { key: 'planned_value', label: 'Պլան. արժեք' },
    { key: 'execution_pct', label: 'Կատարման %' },
  ],
  unorganized: [
    { key: 'cpv_code', label: 'ԳՄԱ կոդ' },
    { key: 'cpv_name', label: 'Անվանում' },
    { key: 'unit', label: 'Չ/մ' },
    { key: 'planned_count', label: 'Պլան. քանակ' },
    { key: 'unit_amount', label: 'Միավ. գին' },
    { key: 'planned_value', label: 'Պլան. արժեք' },
    { key: 'classifier', label: 'Ստորաբ.' },
    { key: 'date', label: 'Ժամկետ' },
  ],
  lifecycle: [
    { key: 'cpv', label: 'ԳՄԱ' },
    { key: 'subdivision', label: 'Ստորաբ.' },
    { key: 'planned', label: 'Պլան. քանակ/արժեք' },
    { key: 'tender', label: 'Մրցույթ' },
    { key: 'winner', label: 'Հաղթող (Մատակարար)' },
    { key: 'contract', label: 'Պայմանագիր' },
    { key: 'supply', label: 'Մատակարարում' },
    { key: 'remaining', label: 'Մնացորդ' },
    { key: 'status', label: 'Կարգավիճակ' },
  ],
  tenders_list: [
    { key: 'name', label: 'Անվանում' },
    { key: 'subdivision', label: 'Ստորաբաժանում' },
    { key: 'cpv_type', label: 'Գնման ձև' },
    { key: 'participants', label: 'Մասնակիցներ' },
    { key: 'winner', label: 'Հաղթող' },
    { key: 'winner_price', label: 'Հաղթող գին' },
    { key: 'status', label: 'Կարգավիճակ' },
  ],
  tenders_cancelled: [
    { key: 'id', label: 'ID' },
    { key: 'code', label: 'Ծածկագիր' },
    { key: 'name', label: 'Անվանում' },
    { key: 'date', label: 'Ժամկետ' },
    { key: 'status', label: 'Կարգավիճակ' },
    { key: 'cancel_reason', label: 'Չեղարկման պատճառ' },
  ],
  contracts_execution: [
    { key: 'status', label: 'Կարգավիճակ' },
    { key: 'code', label: 'Ծածկ. №' },
    { key: 'name', label: 'Անվանում' },
    { key: 'provider', label: 'Մատակարար' },
    { key: 'planned', label: 'Պլանավորված' },
    { key: 'supplied', label: 'Մատակարարված' },
    { key: 'remaining', label: 'Մնացորդ' },
    { key: 'exec_pct', label: 'Կատ. %' },
  ],
  contracts_overdue: [
    { key: 'code', label: 'Ծածկ. №' },
    { key: 'name', label: 'Անվանում' },
    { key: 'provider', label: 'Մատակարար' },
    { key: 'delivery_date', label: 'Մատակ. ժամկետ' },
    { key: 'ordered', label: 'Պատվ.' },
    { key: 'supplied', label: 'Մատակ.' },
    { key: 'overdue_value', label: 'Ժամկ. գումար' },
  ],
  contracts_list: [
    { key: 'code', label: 'Ծածկ. №' },
    { key: 'name', label: 'Անվանում' },
    { key: 'provider', label: 'Մատակարար' },
    { key: 'price', label: 'Գումար' },
    { key: 'start', label: 'Սկիզբ' },
    { key: 'end', label: 'Ավարտ' },
    { key: 'status', label: 'Կարգավիճակ' },
  ],
  contracts_savings: [
    { key: 'code', label: 'Պայմ. №' },
    { key: 'organize_name', label: 'Մրցույթ' },
    { key: 'provider_name', label: 'Մատակարար' },
    { key: 'subdivision', label: 'Ստորաբ.' },
    { key: 'planned_value', label: 'Պլան. արժ.' },
    { key: 'contract_price', label: 'Պայմ. արժ.' },
    { key: 'savings', label: 'Խնայողություն' },
    { key: 'savings_pct', label: 'Խնայ. %' },
    { key: 'sign_date', label: 'Ստ. ամս.' },
  ],
}

function loadCols(key, defaults) {
  try {
    const saved = localStorage.getItem(key)
    return saved ? JSON.parse(saved) : defaults
  } catch (e) { return defaults }
}

export default {
  name: 'OrganizerReports',
  components: { ColumnSelector, AppDateRangePicker, DashboardMonthlyChart },
  mixins: [isMobile],
  data() {
    return {
      activeGroup: 'planning',
      // Planning
      activeTab: 'planning',
      rows: [],
      total: 0,
      page: 1,
      perPage: 15,
      loading: false,
      searchTimer: null,
      filters: { procurement_id: '', cpv_type: '', purchase_type: '', classifier: '', status: '', date_from: '', date_to: '', query: '' },
      procurements: [],
      classifiers: [],
      visibleColumns: {
        planning: loadCols(COLUMN_STORAGE_KEYS.planning, ['cpv_code','cpv_name','cpv_type','purchase_type','unit','planned_count','planned_value','organized_total','remaining','execution_pct','status','classifier']),
        'plan-vs-organized': loadCols(COLUMN_STORAGE_KEYS['plan-vs-organized'], ['cpv_code','cpv_name','planned_count','organized_itender','organized_outside','remaining','planned_value','execution_pct']),
        unorganized: loadCols(COLUMN_STORAGE_KEYS.unorganized, ['cpv_code','cpv_name','unit','planned_count','planned_value','classifier','date']),
        lifecycle: loadCols(COLUMN_STORAGE_KEYS.lifecycle, ['cpv','subdivision','planned','tender','winner','contract','supply','remaining','status']),
        tenders_list: loadCols(COLUMN_STORAGE_KEYS.tenders_list, ['name','subdivision','cpv_type','participants','winner','winner_price','status']),
        tenders_cancelled: loadCols(COLUMN_STORAGE_KEYS.tenders_cancelled, ['id','code','name','date','status','cancel_reason']),
        contracts_execution: loadCols(COLUMN_STORAGE_KEYS.contracts_execution, ['status','code','name','provider','planned','supplied','remaining','exec_pct']),
        contracts_overdue: loadCols(COLUMN_STORAGE_KEYS.contracts_overdue, ['code','name','provider','delivery_date','ordered','supplied','overdue_value']),
        contracts_list: loadCols(COLUMN_STORAGE_KEYS.contracts_list, ['code','name','provider','price','start','end','status']),
        contracts_savings: loadCols(COLUMN_STORAGE_KEYS.contracts_savings, ['code','organize_name','provider_name','planned_value','contract_price','savings','savings_pct','sign_date']),
      },
      // Tenders
      activeTenderTab: 'list',
      tenderRows: [],
      tenderTotal: 0,
      tenderPage: 1,
      tenderLoading: false,
      tenderSearch: '',
      tenderSearchTimer: null,
      cancelledRows: [],
      cancelledTotal: 0,
      cancelledLoading: false,
      competition: {},
      competitionLoading: false,
      // Contracts
      activeContractTab: 'list',
      contractRows: [],
      contractTotal: 0,
      contractPage: 1,
      contractLoading: false,
      contractSearch: '',
      contractSearchTimer: null,
      savingsData: [],
      savingsTotal: 0,
      savingsPage: 1,
      savingsLoading: false,
      savingsFilters: { year: '', date_from: '', date_to: '', subdivision: '', supplier: '', procurement_type: '' },
      savingsSubdivisions: [],
      executionRows: [],
      executionSummary: { total_planned: 0, total_supplied: 0, total_remaining: 0, avg_execution: 0 },
      executionTotal: 0,
      executionPage: 1,
      executionLoading: false,
      overdueRows: [],
      overdueLoading: false,
      // Dashboard
      dash: {},
      dashLoading: false,
      topGoods: [],
      topGoodsLoading: false,
      topSuppliers: [],
      topSuppliersLoading: false,
      departments: [],
      departmentsLoading: false,
      recentContracts: [],
      recentContractsLoading: false,
      upcoming: [],
      upcomingLoading: false,
      // Lifecycle (universal report)
      lifecycleRows: [],
      lifecycleTotal: 0,
      lifecyclePage: 1,
      lifecycleLoading: false,
      lifecycleFilters: { procurement_id: '', classifier: '', date_from: '', date_to: '', winner_user_id: '', cpv_type: '', query: '', status: '' },
      lifecycleSuppliers: [],
      lifecycleSearchTimer: null,
    }
  },
  computed: {
    columnsKey() {
      if (this.activeGroup === 'lifecycle') return 'lifecycle'
      if (this.activeGroup === 'tenders') return 'tenders_' + this.activeTenderTab
      if (this.activeGroup === 'contracts') return 'contracts_' + this.activeContractTab
      return this.activeTab
    },
    currentAllColumns() { return ALL_COLUMNS[this.columnsKey] || [] },
    columnsStorageKey() { return COLUMN_STORAGE_KEYS[this.columnsKey] || ('org_report_' + this.columnsKey + '_cols') },
    currentVisibleColumns: {
      get() { return this.visibleColumns[this.columnsKey] || [] },
      set(val) { this.$set(this.visibleColumns, this.columnsKey, val) },
    },
    activeColumns() {
      return this.currentAllColumns.filter(c => this.currentVisibleColumns.includes(c.key))
    },
    totalPages() { return Math.ceil(this.total / this.perPage) },
    pagesRange() { return this._pageRange(this.page, this.totalPages) },
    tenderTotalPages() { return Math.ceil(this.tenderTotal / 15) },
    savingsTotalPages() { return Math.ceil(this.savingsTotal / 15) },
    savingsPagesRange() { return this._pageRange(this.savingsPage, this.savingsTotalPages) },
    savingsYears() {
      const y = new Date().getFullYear()
      return [y, y-1, y-2, y-3, y-4]
    },
    savingsExportUrl() {
      const p = { ...this.savingsFilters }
      const q = Object.keys(p).filter(k => p[k]).map(k => k + '=' + encodeURIComponent(p[k])).join('&')
      return process.env.VUE_APP_API_URL + 'reports/contracts/savings/export' + (q ? '?' + q : '')
    },
    tenderPagesRange() { return this._pageRange(this.tenderPage, this.tenderTotalPages) },
    contractTotalPages() { return Math.ceil(this.contractTotal / 15) },
    contractPagesRange() { return this._pageRange(this.contractPage, this.contractTotalPages) },
    executionTotalPages() { return Math.ceil(this.executionTotal / 15) },
    executionPagesRange() { return this._pageRange(this.executionPage, this.executionTotalPages) },
    lifecycleTotalPages() { return Math.ceil(this.lifecycleTotal / 15) },
    lifecyclePagesRange() { return this._pageRange(this.lifecyclePage, this.lifecycleTotalPages) },
  },
  mounted() {
    this.loadProcurements()
    this.loadData()
  },
  methods: {
    _pageRange(cur, max) {
      const pages = []
      const start = Math.max(1, cur - 2)
      const end = Math.min(max, start + 4)
      for (let i = start; i <= end; i++) pages.push(i)
      return pages
    },
    setGroup(g) {
      this.activeGroup = g
      if (g === 'planning') this.loadData()
      if (g === 'tenders') {
        if (this.activeTenderTab === 'list') this.loadTenders()
        else if (this.activeTenderTab === 'competition') this.loadCompetition()
        else this.loadCancelled()
      }
      if (g === 'contracts') this.activeContractTab === 'list' ? this.loadContracts() : this.loadSavings()
      if (g === 'dashboard') {
        this.loadDashboard(); this.loadTopGoods(); this.loadTopSuppliers()
        this.loadDepartments(); this.loadRecentContracts(); this.loadUpcoming()
      }
      if (g === 'lifecycle') { this.loadProcurements(); this.loadClassifiers(); this.loadLifecycleSuppliers(); this.loadLifecycle() }
    },
    setTab(tab) { this.activeTab = tab; this.page = 1; this.loadData() },
    setTenderTab(tab) {
      this.activeTenderTab = tab
      if (tab === 'list') this.loadTenders()
      if (tab === 'competition') { this.loadCompetition(); this.loadTopSuppliers() }
      if (tab === 'cancelled') this.loadCancelled()
    },
    setContractTab(tab) {
      this.activeContractTab = tab
      if (tab === 'list') this.loadContracts()
      if (tab === 'execution') this.loadExecution()
      if (tab === 'overdue') this.loadOverdue()
      if (tab === 'savings') { this.loadSavings(); if (!this.savingsSubdivisions.length) this.loadSavingsSubdivisions() }
    },
    onSearch() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => { this.page = 1; this.loadData() }, 400)
    },
    onTenderSearch() {
      clearTimeout(this.tenderSearchTimer)
      this.tenderSearchTimer = setTimeout(() => {
        this.tenderPage = 1
        if (this.activeTenderTab === 'list') this.loadTenders()
        else this.loadCancelled()
      }, 400)
    },
    onContractSearch() {
      clearTimeout(this.contractSearchTimer)
      this.contractSearchTimer = setTimeout(() => { this.contractPage = 1; this.loadContracts() }, 400)
    },
    resetFilters() {
      this.filters = { procurement_id: '', cpv_type: '', purchase_type: '', classifier: '', status: '', date_from: '', date_to: '', query: '' }
      this.loadData()
    },
    async loadProcurements() {
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/procurements')
        this.procurements = data.data || []
      } catch (e) {}
    },
    async loadClassifiers() {
      try {
        const params = this.filters.procurement_id ? { procurement_id: this.filters.procurement_id } : {}
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/classifiers', { params })
        this.classifiers = data.data || []
      } catch (e) {}
    },
    async loadData() {
      if (this.filters.procurement_id) this.loadClassifiers()
      this.loading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + PLANNING_ENDPOINTS[this.activeTab], {
          params: { ...this.filters, page: this.page, limit: this.perPage },
        })
        this.rows = data.data || []
        this.total = data.count || 0
      } catch (e) { this.rows = []; this.total = 0 }
      finally { this.loading = false }
    },
    async loadTenders() {
      this.tenderLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/tenders', {
          params: { page: this.tenderPage, limit: 15, query: this.tenderSearch || undefined },
        })
        this.tenderRows = data.data || []
        this.tenderTotal = data.count || 0
      } catch (e) { this.tenderRows = []; this.tenderTotal = 0 }
      finally { this.tenderLoading = false }
    },
    async loadCompetition() {
      this.competitionLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/tenders/competition')
        this.competition = data.data || {}
      } catch (e) { this.competition = {} }
      finally { this.competitionLoading = false }
    },
    async loadCancelled() {
      this.cancelledLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/tenders/cancelled', {
          params: { page: 1, limit: 50, query: this.tenderSearch || undefined },
        })
        this.cancelledRows = data.data || []
        this.cancelledTotal = data.count || 0
      } catch (e) { this.cancelledRows = []; this.cancelledTotal = 0 }
      finally { this.cancelledLoading = false }
    },
    async loadContracts() {
      this.contractLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/contracts', {
          params: { page: this.contractPage, limit: 15, query: this.contractSearch || undefined },
        })
        this.contractRows = data.data || []
        this.contractTotal = data.count || 0
      } catch (e) { this.contractRows = []; this.contractTotal = 0 }
      finally { this.contractLoading = false }
    },
    async loadExecution() {
      this.executionLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/contracts/execution', {
          params: { page: this.executionPage, limit: 15 },
        })
        this.executionRows = data.data || []
        this.executionTotal = data.count || 0
        this.executionSummary = data.summary || { total_planned: 0, total_supplied: 0, total_remaining: 0, avg_execution: 0 }
      } catch (e) {
        this.executionRows = []; this.executionTotal = 0
      } finally { this.executionLoading = false }
    },
    async loadOverdue() {
      this.overdueLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/contracts/overdue')
        this.overdueRows = data.data || []
      } catch (e) { this.overdueRows = [] }
      finally { this.overdueLoading = false }
    },
    async loadSavings() {
      this.savingsLoading = true
      try {
        const params = { page: this.savingsPage, limit: 15, ...this.savingsFilters }
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/contracts/savings', { params })
        this.savingsData = data.data || []
        this.savingsTotal = data.count || 0
      } catch (e) { this.savingsData = []; this.savingsTotal = 0 }
      finally { this.savingsLoading = false }
    },
    onSavingsFilter() { this.savingsPage = 1; this.loadSavings() },
    onSavingsFilterDebounce() {
      clearTimeout(this._savingsTimer)
      this._savingsTimer = setTimeout(() => { this.savingsPage = 1; this.loadSavings() }, 400)
    },
    changeSavingsPage(p) { this.savingsPage = p; this.loadSavings() },
    async loadSavingsSubdivisions() {
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/subdivisions')
        this.savingsSubdivisions = data.data || []
      } catch (e) { this.savingsSubdivisions = [] }
    },
    async loadDashboard() {
      this.dashLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/dashboard')
        this.dash = data.data || {}
      } catch (e) { this.dash = {} }
      finally { this.dashLoading = false }
    },
    async loadTopGoods() {
      this.topGoodsLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/top-goods')
        this.topGoods = data.data || []
      } catch (e) { this.topGoods = [] }
      finally { this.topGoodsLoading = false }
    },
    async loadTopSuppliers() {
      this.topSuppliersLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/top-suppliers')
        this.topSuppliers = data.data || []
      } catch (e) { this.topSuppliers = [] }
      finally { this.topSuppliersLoading = false }
    },
    async loadDepartments() {
      this.departmentsLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/dashboard/departments')
        this.departments = data.data || []
      } catch (e) { this.departments = [] }
      finally { this.departmentsLoading = false }
    },
    async loadRecentContracts() {
      this.recentContractsLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/dashboard/recent-contracts')
        this.recentContracts = data.data || []
      } catch (e) { this.recentContracts = [] }
      finally { this.recentContractsLoading = false }
    },
    async loadUpcoming() {
      this.upcomingLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/dashboard/upcoming')
        this.upcoming = data.data || []
      } catch (e) { this.upcoming = [] }
      finally { this.upcomingLoading = false }
    },
    recentContractStatusLabel(s) {
      return { completed: '🔵 Ավարտված', overdue: '🔴 Ժամկետանց', partial: '🟠 Մասնակի կատարված', active: '🟢 Կատարվում է', pending: '⚪ Սպասվող' }[s] || '—'
    },
    upcomingColorClass(c) {
      return { red: 'text-danger', orange: 'text-warning', blue: 'text-info', green: 'text-success' }[c] || ''
    },
    upcomingIcon(c) {
      return { red: '🔴', orange: '🟠', blue: '🔵', green: '🟢' }[c] || '⚪'
    },
    async loadLifecycle(page) {
      if (page) this.lifecyclePage = page
      this.lifecycleLoading = true
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/lifecycle', {
          params: { ...this.lifecycleFilters, page: this.lifecyclePage, limit: 15 },
        })
        this.lifecycleRows = data.data || []
        this.lifecycleTotal = data.count || 0
      } catch (e) { this.lifecycleRows = []; this.lifecycleTotal = 0 }
      finally { this.lifecycleLoading = false }
    },
    changeLifecyclePage(p) {
      if (p < 1 || p > this.lifecycleTotalPages) return
      this.loadLifecycle(p)
    },
    onLifecycleSearch() {
      clearTimeout(this.lifecycleSearchTimer)
      this.lifecycleSearchTimer = setTimeout(() => { this.loadLifecycle(1) }, 400)
    },
    resetLifecycleFilters() {
      this.lifecycleFilters = { procurement_id: '', classifier: '', date_from: '', date_to: '', winner_user_id: '', cpv_type: '', query: '', status: '' }
      this.loadLifecycle(1)
    },
    async loadLifecycleSuppliers() {
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/builder/suppliers')
        this.lifecycleSuppliers = data.data || []
      } catch (e) { this.lifecycleSuppliers = [] }
    },
    async exportSavingsExcel() {
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/contracts/savings/export', {
          params: { ...this.savingsFilters },
          responseType: 'blob',
        })
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'savings-report-' + new Date().toISOString().slice(0, 10) + '.xlsx')
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {}
    },
    async exportLifecycleExcel() {
      try {
        const { data } = await this.$client.get(process.env.VUE_APP_API_URL + 'reports/lifecycle/export', {
          params: { ...this.lifecycleFilters },
          responseType: 'blob',
        })
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'lifecycle-report-' + new Date().toISOString().slice(0, 10) + '.xlsx')
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {}
    },
    lifecycleStatusBadge(s) {
      return {
        planned: 'badge-secondary',
        organizing: 'badge-info',
        contract: 'badge-warning',
        completed: 'badge-success',
        cancelled: 'badge-danger',
      }[s] || 'badge-secondary'
    },
    lifecycleStatusLabel(s) {
      return {
        planned: 'Պլանավորում',
        organizing: 'Կազմակերպվում է',
        contract: 'Պայմանագիր',
        completed: 'Ավարտված',
        cancelled: 'Չեղարկված',
      }[s] || '—'
    },
    async exportExcel() {
      const params = new URLSearchParams({ ...this.filters })
      window.open(process.env.VUE_APP_API_URL + 'reports/export/planning?' + params.toString(), '_blank')
    },
    changePage(p) {
      if (p < 1 || p > this.totalPages) return
      this.page = p; this.loadData()
    },
    changeTenderPage(p) {
      if (p < 1 || p > this.tenderTotalPages) return
      this.tenderPage = p; this.loadTenders()
    },
    changeContractPage(p) {
      if (p < 1 || p > this.contractTotalPages) return
      this.contractPage = p; this.loadContracts()
    },
    changeExecutionPage(p) {
      if (p < 1 || p > this.executionTotalPages) return
      this.executionPage = p; this.loadExecution()
    },
    formatDate(d) {
      return d ? this.$options.filters.moment(d, 'DD.MM.YYYY') : '—'
    },
    isVisible(key) { return this.currentVisibleColumns.includes(key) },
    pctBadge(pct) {
      if (pct >= 100) return 'badge-success'
      if (pct >= 50) return 'badge-warning'
      return 'badge-danger'
    },
    lifecycleBadge(s) {
      return { 1: 'badge-primary', 2: 'badge-warning', 3: 'badge-danger', 4: 'badge-success' }[s] || 'badge-secondary'
    },
    lifecycleLabel(s) {
      return { 1: 'Կազմակերպվում է', 2: 'Պայմանագիր', 3: 'Չեղարկված', 4: 'Ավարտված' }[s] || '—'
    },
    planStatusBadge(s) {
      return { 0: 'badge-secondary', 1: 'badge-primary', 2: 'badge-warning' }[s] || 'badge-secondary'
    },
    planStatusLabel(s) {
      return { 0: 'Ակտիվ', 1: 'Հաստատված', 2: 'Խմբագրման մեջ' }[s] || '—'
    },
    tenderStatusBadge(s) {
      if (s === 1) return 'badge-success'
      if (s === 2) return 'badge-warning'
      return 'badge-secondary'
    },
    tenderStatusLabel(s) {
      if (s === 1) return 'Հաստատված'
      if (s === 2) return 'Խմբագրման մեջ'
      return 'Նախագիծ'
    },
    cpvTypeLabel(t) {
      return { 1: 'Ապրանք', 2: 'Ծառայություն', 3: 'Աշխատանք' }[t] || '—'
    },
    purchaseTypeLabel(t) {
      return { 3: 'Լավագույն առաջարկ', 2: 'Բաց աճուրդ', 1: 'Փակ գներով' }[t] || '—'
    },
    formatNumeral(value, format) {
      return this.$options.filters.numeral(value, format)
    },
    cancelReasonLabel(r) {
      if (r === 'not_requirement_purchase') return 'Դադարել է գոյություն ունենալ գնման պահանջը'
      if (r === 'need_change') return 'Անհրաժեշտություն է առաջացել փոփոխել կազմակերպված մրցույթի պայմանները'
      return r || '—'
    },
    localizedName(val) {
      if (!val) return '—'
      let obj = val
      if (typeof val === 'string' && val.trim().startsWith('{')) {
        try {
          obj = JSON.parse(val)
        } catch (e) {
          return val
        }
      }
      if (typeof obj === 'object') return obj.hy || obj.en || obj.ru || '—'
      return obj
    },
  },
}
</script>

<style scoped>
.report-table th {
  font-size: 0.8rem; font-weight: 600; background: #f8f9fa; color: #495057;
  border-top: none; padding: 6px 12px; vertical-align: middle; text-align: left;
}
.report-table td { font-size: 0.8rem; padding: 6px 12px; vertical-align: middle; text-align: left; }
.report-table tr:hover { background: #f0f4ff; }
.group-tabs {
  border-bottom: none;
}
.group-tabs .nav-link {
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  color: #6c757d;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 8px 16px;
  transition: color 0.15s, border-color 0.15s;
}
.group-tabs .nav-link:hover {
  color: #556ee6;
  border-color: transparent;
}
.group-tabs .nav-link.active {
  color: #556ee6;
  background: transparent;
  border-color: #556ee6;
}
.sub-tabs {
  background: #f1f3f9;
  border-radius: 8px;
  padding: 3px;
  display: inline-flex;
  border: none;
}
.sub-tabs .nav-link {
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 5px 14px;
  color: #6c757d;
  transition: color 0.15s, background 0.15s;
}
.sub-tabs .nav-link:hover {
  color: #495057;
}
.sub-tabs .nav-link.active {
  background: #fff;
  color: #556ee6;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0,0,0,.08);
}
.filter-label { font-size: 0.75rem; font-weight: 600; color: #6c757d; margin-bottom: 3px; display: block; white-space: nowrap; }
.kpi-card { border-radius: 8px; transition: box-shadow 0.2s; height: 100%; }
.kpi-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,.1); }
.kpi-icon { font-size: 28px; margin-bottom: 8px; }
.kpi-value { font-size: 1.4rem; font-weight: 700; color: #343a40; line-height: 1.2; }
.kpi-label { font-size: 0.75rem; color: #6c757d; margin-top: 4px; }
</style>
